import Axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import StarRating from "react-star-ratings";
import saveLog from "../services/saveLog";
import url from "../services/url";
import swal from "sweetalert";
import axios from "../services/axios";
import RSelect from "react-select";
import { Alert, Image } from "antd";
import ReactLoading from "react-loading";
import { message } from "antd";
import { Trf_Edit_Right, Reject_Rights } from "../umConfig";
import TinAssign from "../pages/Dashboard/TinManagement/TinAssign";
import { CopyOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Pagination } from "antd";
import useAxios from "../hooks/useAxios";
// import { CopyOutlined } from "@ant-design/icons";
import LoadingArea from "./LoadingArea";
import ProfilePhotoMatch from "./components/ProfilePhotoMatch";
import ProfilePhotoMatchAgent from "./components/ProfilePhotoMatchAgent";
import { useHistory } from "react-router-dom";
import TinManage from "../pages/Dashboard/components/TinManage";
import { changeDateAndTimeFormat } from "../utils/commonFunctions";

function getVLevel(score) {
  if (score >= 71)
    return "6"; // C1+ / C2
  else if (score >= 60)
    return "5"; // C1
  else if (score >= 50)
    return "4"; // B2
  else if (score >= 40)
    return "3"; // B1
  else if (score >= 30)
    return "2"; // A2
  else if (score >= 20)
    return "1"; // A1
  else return "1"; // Below CEFR A1
}

function getAgentInterviewMode(agentFaceMatchStatus, noRecordReason) {
  if (
    agentFaceMatchStatus === "Missing" &&
    noRecordReason === "Telephonic Interview"
  ) {
    return "Telephonic Interview";
  }

  if (
    agentFaceMatchStatus === "Missing" &&
    noRecordReason === "WFO Interview (In-Person, No Phygital Capture)"
  ) {
    return "In-Person Interview";
  }

  return "Video Interview";
}

function Interview({
  interview,
  index,
  candidate,
  interviews,
  processes,
  loadCandidate,
  refreshInterviewDetails,
  s3Files,
  getInterviews,
  getDoc,
  tinData,
  allInterviewStatus,
  rejectionReasonParameterList,
  expandedInterviews,
  getProcessBasedVersantConf,
  canTakeInterview,
  canMakeInterviewEditable,
  canEditTrf,
  isCallDiscussionPending,
  // onChangeCandidateProcess,
}) {
  const api = useAxios();
  const userId = localStorage.getItem("user.id");
  const userRole = localStorage.getItem("user.role") || "";
  const isDevAdmin = userRole.toLowerCase() === "dev_admin";
  const history = useHistory();
  const [load, setLoad] = useState(false);
  const [editStatus, setEditStatus] = useState(false);
  const [remarks, setRemarks] = useState(interview.remarks || "");
  const [versant, setVersant] = useState(interview.versantScore || false);
  const [allBindTins, setAllBindTins] = useState([]);
  const [expectedVersantScore, setExpectedVersantScore] = useState(
    interview.expectedVersantScore || "",
  );
  const [expectedVersantScoreDisable, setExpectedVersantScoreDisable] =
    useState(false);
  const [versantRoundTin, setVersantRoundTin] = useState("");
  const [versantRoundTinType, setVersantRoundTinType] = useState("");
  const [interviewStatus, setInterviewStatus] = useState(interview?.status);
  const [disable, setDisable] = useState(false);
  const [rejectedReason, setRejectedReason] = useState(
    interview?.rejectionReason,
  );
  const [interviewMode, setInterviewMode] = useState("Telephonic");
  const [photoMatch, setPhotoMatch] = useState(null);
  const [concent, setConcent] = useState(false);
  const [error, setError] = useState(null);
  const [clientRoundExist, setClientRoundExist] = useState(
    interview.status === "Pending" ? null : interview.clientRoundExist,
  );
  const [isReassigning, setIsReassigning] = useState(false);
  const [selectedInterviewer, setSelectedInterviewer] = useState(null);
  const [isVersantNotRequired, setIsVersantNotRequired] = useState(
    interview.isVersantNotRequired || false,
  );
  const [versantNotRequiredReason, setVersantNotRequiredReason] = useState(
    interview.versantNotRequiredReason || "",
  );

  const [agentFaceMatchStatus, setAgentFaceMatchStatus] = useState(
    interview?.phygitalVerification?.matched === true
      ? "Matched"
      : interview?.phygitalVerification?.matched === false
        ? "Mismatch"
        : (interview?.profileImageMatchStatus === true
          ? "Matched"
          : interview?.profileImageMatchStatus === false
            ? "Mismatch"
            : (interview?.phygitalVerification?.bestFrameImageUrl
              ? "Mismatch"
              : "Missing"))
  );
  const [agentNoRecordReason, setAgentNoRecordReason] = useState(
    interview?.noRecordReason || ""
  );
  const [recruiterFaceMatchResponse, setRecruiterFaceMatchResponse] = useState(
    interview?.recruiterFaceMatchResponse || ""
  );

  useEffect(() => {
    const computedStatus =
      interview?.phygitalVerification?.matched === true
        ? "Matched"
        : interview?.phygitalVerification?.matched === false
          ? "Mismatch"
          : interview?.profileImageMatchStatus === true
            ? "Matched"
            : interview?.profileImageMatchStatus === false
              ? "Mismatch"
              : interview?.phygitalVerification?.bestFrameImageUrl
                ? "Mismatch"
                : "Missing";

    setAgentFaceMatchStatus(computedStatus);
    if (interview?.noRecordReason) {
      setAgentNoRecordReason(interview.noRecordReason);
    }
    if (interview?.recruiterFaceMatchResponse) {
      setRecruiterFaceMatchResponse(interview.recruiterFaceMatchResponse);
    }
  }, [
    interview?.phygitalVerification?.matched,
    interview?.phygitalVerification?.bestFrameImageUrl,
    interview?.profileImageMatchStatus,
    interview?.noRecordReason,
    interview?.recruiterFaceMatchResponse,
  ]);
  const isAgentCandidate = candidate?.trf?.candidateType !== "Non-Agent";
  const workModal = isAgentCandidate
    ? String(candidate?.trf?.workModal || "WFO)").toUpperCase()
    : null;

  const [skills, setSkills] = useState(
    candidate?.trf?.skills
      .split(",")
      .filter((skill) => {
        return skill !== "";
      })
      .map((skill) => {
        let initialSkill = {
          name: skill.trim(),
          rating: 1,
          review: "",
        };
        interview.rating.forEach((test) => {
          if (test.name === initialSkill.name) {
            initialSkill = test;
          }
        });
        return initialSkill;
      }),
  );

  const currentVoice = allBindTins?.find(
    (t) => t?.tinType === "voice" && t?.tinStatus,
  );

  const currentWritten = allBindTins?.find(
    (t) => t?.tinType === "written" && t?.tinStatus,
  );

  const tinWrittenNumber = currentWritten?.tinNo || versantRoundTin || "";
  const tinVoiceNumber = currentVoice?.tinNo || versantRoundTin || "";

  const voiceScore = currentVoice?.scoreParts?.[0]?.scoreValue || 0;
  const writtenScore = currentWritten?.scoreParts?.[0]?.scoreValue || 0;
  const versantType = tinData?.versantBasedTRF?.versantType;

  const minVoiceScore = tinData?.versantBasedTRF?.voiceScore || 0;
  const minWrittenScore = tinData?.versantBasedTRF?.writtenScore || 0;

  const getTinDetails = () => {
    const details = [];
    if (versantType === "voice") {
      details?.push({
        tinNo: tinVoiceNumber,
        tintype: versantType,
      });
    }
    if (versantType === "written") {
      details?.push({
        tinNo: tinWrittenNumber,
        tintype: versantType,
      });
    }
    return details;
  };

  const checkVersantCompleted = () => {
    if (versantType === "voice") {
      return voiceScore >= minVoiceScore;
    }

    if (versantType === "written") {
      return writtenScore >= minWrittenScore;
    }

    if (versantType === "both") {
      return voiceScore >= minVoiceScore && writtenScore >= minWrittenScore;
    }

    return false;
  };

  const autoRejectCandidate = async (simulatedMatchStatus, simulatedRecruiterResponse) => {
    try {
      setLoad(true);
      setDisable(true);

      const payload = {
        finished: true,
        rating: skills,
        remarks: "Photo Mismatch",
        status: "Rejected",
        rejectionReason: "Photo Mismatch",
        clientRoundExist,
        isVersantNotRequired,
        versantNotRequiredReason: isVersantNotRequired ? versantNotRequiredReason : "",
        modeOfInterview: "Video Interview",
        profileImageMatchStatus: simulatedMatchStatus === "Matched" ? true : simulatedMatchStatus === "Mismatch" ? false : null,
        recruiterFaceMatchResponse: simulatedRecruiterResponse,
        noRecordReason: "",
        expectedVersantScore: "",
        typingTest: false,
        typingTestRemarks: "",
        versantScore: versant,
        versantVoiceScore: voiceScore || null,
        versantWrittenScore: writtenScore || null,
        tinDetails: getTinDetails(),
        clientRound: false,
        clientRoundRemarks: "",
        interviewBy: userId,
        L4AttemptBy: interview.type === "final" ? userId : "",
      };

      await api.patch(
        `/interviews/${interview._id}`,
        payload,
        {
          tokenType: "user",
        },
      );

      swal({
        title: "Submitted successfully",
        icon: "success",
      });

      await Promise.all([
        loadCandidate(),
        getInterviews(candidate?._id),
        getDoc(),
      ]);
    } catch (err) {
      console.error(err);
      swal({
        title: err?.response?.data?.error || "Something went wrong",
        icon: "error",
      });
    } finally {
      setLoad(false);
      setDisable(false);
    }
  };

  async function onClickSubmit() {
    if (interviewStatus === "Selected") {
      if (!candidate?.callMasterId || !candidate?.callStatusMasterId) {
        return swal({
          icon: "error",
          title: "Please fill Call Discussion Status first.",
        });
      }

      if (candidate?.callMasterId !== "Connected" && !candidate?.IsCallConnected) {
        return swal({
          icon: "error",
          title: "Call Discussion Status must be Connected to submit interview.",
        });
      }
    }

    let error = {};

    const isPhygitalDecisionPending = interview?.phygitalVerification?.candidateJoined && !interview?.phygitalVerification?.submittedAt;
    if (isPhygitalDecisionPending && !isDevAdmin) {
      swal({
        title: "Please complete the interview verification process in Phygital first.",
        icon: "warning",
      });
      return;
    }

    const interviewType = interview.type;

    // if (interviewType === "L1" && expectedVersantScore === "") {
    //   error.versantScore = "Versant score is required.";
    // }

    if (interviewType === "versant" && clientRoundExist === null) {
      error.clientRoundExist = "Please choose client round is required or not.";
    }

    if (
      interviewType === "versant" &&
      isVersantNotRequired &&
      !versantNotRequiredReason
    ) {
      error.versantNotRequiredReason =
        "Please select a reason for Not Required.";
    }

    if (
      !(interviewType === "versant" && isVersantNotRequired) &&
      interviewStatus !== "Rejected" &&
      remarks?.trim() === ""
    ) {
      error.remark = "Remarks is required.";
    }

    if (
      (interviewStatus === "Pending" && interviewStatus !== "") ||
      interviewStatus === ""
    ) {
      error.status = "Please select the interview status.";
    }

    if (interviewStatus === "Rejected" && rejectedReason === "") {
      error.rejectReason = "Please select reason before submit.";
    }

    const isAgent = candidate?.trf?.candidateType !== "Non-Agent";
    if (isAgent) {
      if (
        agentFaceMatchStatus === "Missing" &&
        workModal === "WFH" &&
        !agentNoRecordReason
      ) {
        error.agentNoRecordReason = "Please select a reason for missing photo.";
      }
      if (
        (agentFaceMatchStatus === "Mismatch" || agentFaceMatchStatus === "Matched") &&
        !recruiterFaceMatchResponse &&
        (
          (!interview?.finished && (interview?.status === "Selected" || interview?.status === "Rejected")) ||
          !interview?.phygitalVerification?.interviewStatus ||
          interview?.phygitalVerification?.interviewStatus?.toLowerCase() === "no-response" ||
          interview?.phygitalVerification?.interviewStatus?.toLowerCase() === "failure"
        )
      ) {
        return swal({
          icon: "warning",
          title: "Please select Recruiter Face Match Decision.",
        });
      }
    }

    setError(error);

    for (let key in error) {
      if (error[key]) {
        return;
      }
    }

    if (
      interviewStatus === "Selected" &&
      interviewType === "versant" &&
      !isVersantNotRequired &&
      !checkVersantCompleted()
    ) {
      return swal({
        icon: "error",
        title: "Candidate not eligible for Versant Interview.",
      });
    }

    if (
      !isAgent &&
      interviewStatus === "Selected" &&
      (interviewMode === "Video Call" || interviewMode === "In Person")
    ) {
      if (!candidatePhoto?.value) {
        return swal({
          icon: "error",
          title: "Please upload the candidate photo before proceeding.",
        });
      }
      if (photoMatch === null || !concent) {
        return swal({
          icon: "error",
          title: "Please Mark Photo Mismatch Status and Consent.",
        });
      }
    }

    if (interviewStatus === "Selected") {
      if (
        !candidate?.responses ||
        candidate?.responses?.length === 0 ||
        !(candidate?.isFormSubmitted === true || candidate?.isFormSubmitted === "true")
      ) {
        return swal({
          icon: "error",
          title: "Please complete candidate form",
        });
      }

      if (candidate?.trf?.Status === false) {
        return swal({
          icon: "error",
          title: "Please Edit Location & TRF",
        });
      }
      //  const userEmail = localStorage.getItem("user.email");
      //  const isBypassUser = ["abhishek.vashisht@maxicus.com", "sarbjeet.singh@igzy.com"].includes(userEmail);

      // if (interviewType === "L1" && candidate?.languageConfidenceScore?.status !== 'completed' && !isBypassUser) {
      //   return swal({
      //     className: "mandatory-swal",
      //     icon: "warning",
      //     title: "Comm. Skill Test is mandatory before marking the candidate as “L1 Selected”. Please ensure the candidate completes the test to proceed.",
      //   });
      // }
    }
    try {
      setLoad(true);
      setDisable(true);

      await handleAutoSave();
      await Promise.all([
        loadCandidate(),
        getInterviews(candidate?._id),
        getDoc(),
      ]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
      setDisable(false);
    }
  }

  async function onClickUnSubmit() {
    try {
      saveLog(
        "INTERVIEW_EDIT",
        `Reverted Final submitted interview for candidate ${candidate.name}`,
      );
      await api.patch(
        `interviews/InterviewStatus/${interview._id}`,
        {
          finished: false,
        },
        {
          tokenType: "user",
        },
      );

      window.location.reload();
    } catch (e) {
      console.error(e);
    }
  }

  const clientRoundExistHandler = (e) => {
    e.target.value === "false"
      ? setClientRoundExist(false)
      : setClientRoundExist(true);
  };

  const handleAutoSave = async () => {
    if (!interviewStatus) return;

    const isAgent = candidate?.trf?.candidateType !== "Non-Agent";
    const effectiveNoRecordReason =
      isAgent &&
        agentFaceMatchStatus === "Missing" &&
        workModal === "WFO" &&
        !agentNoRecordReason
        ? "WFO Interview (In-Person, No Phygital Capture)"
        : agentNoRecordReason;

    try {
      const payload = {
        finished:
          interviewStatus === "Selected" || interviewStatus === "Rejected",
        rating: skills,
        remarks:
          interview.type === "versant" && isVersantNotRequired ? "" : remarks,
        status: interviewStatus,
        rejectionReason: interviewStatus === "Rejected" ? rejectedReason : "",
        clientRoundExist,
        isVersantNotRequired,
        versantNotRequiredReason: isVersantNotRequired
          ? versantNotRequiredReason
          : "",

        modeOfInterview: isAgent
          ? getAgentInterviewMode(
            agentFaceMatchStatus,
            effectiveNoRecordReason,
          )
          : (interviewStatus === "Selected" ? interviewMode : ""),

        profileImageMatchStatus: isAgent
          ? (agentFaceMatchStatus === "Matched" ? true : agentFaceMatchStatus === "Mismatch" ? false : null)
          : (interviewStatus === "Selected" ? photoMatch : null),

        recruiterFaceMatchResponse: isAgent ? recruiterFaceMatchResponse : "",
        noRecordReason: isAgent ? effectiveNoRecordReason : "",

        expectedVersantScore: "",
        typingTest: false,
        typingTestRemarks: "",
        versantScore: versant,
        versantVoiceScore: voiceScore || null,
        versantWrittenScore: writtenScore || null,
        tinDetails: getTinDetails(),
        clientRound: false,
        clientRoundRemarks: "",

        interviewBy: userId,
        L4AttemptBy: (interview.type === "final" || interview.type === "L4") ? userId : "",
      };

      await api.patch(`/interviews/${interview._id}`, payload, {
        tokenType: "user",
      });

      if (interviewStatus === "Suspicious") {
        message.success(
          "Candidate marked as suspicious and inactive successfully.",
        );
        history.push(`/candidate_dashboard?tab=Application_Received`);
        return;
      }

      swal({
        title: "Submitted successfully",
        icon: "success",
      });
    } catch (err) {
      console.error(err);
      swal({
        title: err?.response?.data?.error || "Something went wrong",
        icon: "error",
      });
    }
  };

  const getOldTinBindByHr = async () => {
    try {
      const { data } = await api.get(
        `/manageTin/Selected/candidate/${candidate._id}/interviewerBy/${userId}`,
        {
          tokenType: "user",
        },
      );
      setVersantRoundTin(data?.tin?.tinNo);
      setVersantRoundTinType(data?.tin?.tinType);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (
      (interview?.status === "Selected" || interview?.status === "Rejected") &&
      !canTakeInterview
    ) {
      setEditStatus(true);
    }

    if (interview.type === "versant") {
      getBindTinByHr();
      getOldTinBindByHr();
    }
  }, [interview]);

  const getBindTinByHr = async () => {
    try {
      const { data } = await api.get(
        `/manageTin/candidateTinListByHR/${candidate?._id}`,
        {
          tokenType: "user",
        },
      );

      setAllBindTins(data?.tinDetails);
    } catch (err) {
      console.error(err);
    }
  };

  const handleRejectionStatus = async (e) => {
    const selectedValue = e.target.value;

    // Show popup and block "Selected" when recruiter confirmed photo mismatch
    if (isAgentCandidate && recruiterFaceMatchResponse === "Mismatched" && selectedValue === "Selected") {
      swal({
        icon: "error",
        title: "Cannot select candidate with Photo Mismatch.",
        text: "The Recruiter Face Match Decision is 'Photos Mismatched'. You cannot mark the candidate as Selected.",
      });
      return;
    }

    setRejectedReason("");
    setInterviewStatus(selectedValue);
  };

  const handleStatusReason = (e) => {
    setRejectedReason(e.target.value);
  };

  useEffect(() => {
    const isTestDone =
      candidate?.languageConfidenceScore &&
      candidate?.languageConfidenceScore?.status === "completed";
    const languageData =
      candidate?.languageConfidenceScore?.overallScores || {};
    const _score = languageData["overall"]?.overall_score;
    const _gradeData = getVLevel(_score);
    if (isTestDone) {
      setExpectedVersantScore(_gradeData);
      setExpectedVersantScoreDisable(true);
    }
  }, [candidate?.languageConfidenceScore]);

  const candidatePhoto = candidate?.responses?.find((ele) => {
    if (ele?.element.type === "file" || ele?.element?.type === "capturephoto") {
      const fieldName = ele?.element.properties.label;
      if (fieldName.toLowerCase().indexOf("profile photo") === 0) {
        return true;
      }
    }
  });



  const filterStatus = allInterviewStatus.filter((ele) =>
    photoMatch === null
      ? ele?.name !== "Suspicious"
      : photoMatch
        ? ele?.name !== "Suspicious"
        : ele?.name === "Suspicious",
  );

  return (
    <>
      <div>
        {load && (
          <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
        )}
        <div className="card my-2 border-0">
          <div
            className={
              expandedInterviews.includes(interview._id)
                ? "card-body-animated"
                : "card-body-animated card-body-hidden"
            }
          >
            <div className="card-body px-2 py-0">
              {!interview?.finished && isAgentCandidate && (
                <div className="d-flex align-items-center justify-content-between my-2 p-2" style={{ background: '#f8f9fc', border: '1px solid #e3e6f0', borderRadius: '6px' }}>
                  {interview?.link ? (
                    <div className="d-flex align-items-center gap-2" style={{ flex: 1, marginRight: '10px' }}>
                      <span style={{ fontWeight: '700', color: '#4e73df', fontSize: '11px', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>Session Link:</span>
                      <a
                        href={interview.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary font-weight-bold mx-1"
                        style={{ fontSize: '11px', textDecoration: 'underline', whiteSpace: 'nowrap' }}
                      >
                        Meeting Link
                      </a>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-center m-0"
                        onClick={() => {
                          navigator.clipboard.writeText(interview.link);
                          message.success("Interview link copied to clipboard!");
                        }}
                        style={{ height: '24px', width: '28px', padding: 0 }}
                      >
                        <CopyOutlined style={{ fontSize: '12px' }} />
                      </button>
                    </div>
                  ) : (
                    <div style={{ flex: 1 }}></div>
                  )}
                  {isAgentCandidate && (
                    <span className="px-2" style={{
                      borderRadius: '10px',
                      fontSize: '9px',
                      fontWeight: 'bold',
                      backgroundColor: interview.sendInterviewLink ? '#d4edda' : '#e2e3e5',
                      color: interview.sendInterviewLink ? '#155724' : '#383d41',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '4px',
                      height: '20px',
                      whiteSpace: 'nowrap'
                    }}>
                      {interview.sendInterviewLink ? '● LINK SENT' : '● LINK NOT SENT'}
                    </span>
                  )}
                </div>
              )}
              <table className="table table-candidate">
                <tbody>
                  {interview?.finished && interview?.status === "Selected" ? (
                    <>
                      <tr>
                        <td width={"149px"}>
                          <strong>Interview Type</strong>
                        </td>
                        <td>
                          {interview?.isVersantNotRequired
                            ? "Not Required"
                            : interview?.modeOfInterview}
                        </td>
                      </tr>

                    </>
                  ) : (
                    <></>
                  )}
                  <tr>
                    <td width={"149px"}>
                      <strong>Message</strong>
                    </td>
                    <td>
                      {interview.description}
                      {interview.description === "" ||
                        interview.description == null ? (
                        <span className="text-danger">
                          No message specified.
                        </span>
                      ) : null}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Interviewer</strong>
                    </td>
                    <td>{interview.interviewer}</td>
                  </tr>
                  {interview.type === "video" ? (
                    <tr>
                      <td>
                        <strong>Link</strong>
                      </td>
                      <td>
                        {interview.link}
                        {interview.link === "" || interview.link == null ? (
                          <span className="text-danger">
                            No link specified.
                          </span>
                        ) : null}
                      </td>
                    </tr>
                  ) : null}

                  <tr>
                    <td>
                      <strong>Start Time</strong>
                    </td>
                    <td>
                      {interview.start}
                      {interview.start === "" || interview.start == null ? (
                        <span className="text-danger">No start specified.</span>
                      ) : null}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>End Time</strong>
                    </td>
                    <td>
                      {interview.end}
                      {interview.end === "" || interview.end == null ? (
                        <span className="text-danger">No end specified.</span>
                      ) : null}
                    </td>
                  </tr>
                </tbody>
              </table>

              {interview.type === "versant" && (
                <div>
                  <div className="mt-1 mb-2 px-1">
                    <h4 className="hr-ratings-title">
                      Versant Interview Ratings
                    </h4>
                    <TinManage
                      getProcessBasedVersantConf={getProcessBasedVersantConf}
                      getBindTinByHr={getBindTinByHr}
                      candidate={candidate}
                      tinData={tinData}
                      interview={interview}
                      versantRoundTin={versantRoundTin}
                      versantRoundTinType={versantRoundTinType}
                      allBindTins={allBindTins}
                    />
                  </div>

                  <div className="row mt-2 mb-2 px-1">
                    <div className="col-12">
                      <h4 className="col mt-1 hr-ratings-title p-0">
                        Is client round required ?
                        <span style={{ color: "red" }}>*</span>
                      </h4>
                    </div>
                    <div
                      className="col-12 d-flex mt-2"
                      style={{ width: "100%" }}
                    >
                      <div className="" style={{ flex: "1 1" }}>
                        <input
                          {...{
                            onChange: clientRoundExistHandler,
                            id: "clientRoundExist_yes",
                            type: "radio",
                            name: "clientRoundExist",
                            disabled: interview.finished || !canTakeInterview,
                            value: true,
                            ...(interview.status === "Pending" &&
                              !isVersantNotRequired
                              ? null
                              : {
                                checked: clientRoundExist === true,
                              }),
                          }}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="clientRoundExist_yes">Yes</label>
                      </div>
                      <div className="" style={{ flex: "1 1" }}>
                        <input
                          {...{
                            onChange: clientRoundExistHandler,
                            id: "clientRoundExist_no",
                            type: "radio",
                            name: "clientRoundExist",
                            disabled: interview.finished || !canTakeInterview,
                            value: false,
                            ...(interview.status === "Pending" &&
                              !isVersantNotRequired
                              ? null
                              : {
                                checked: clientRoundExist === false,
                              }),
                          }}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="clientRoundExist_no">No</label>
                      </div>
                    </div>
                  </div>
                  {error?.clientRoundExist && (
                    <span style={{ color: "red" }}>
                      {error?.clientRoundExist}
                    </span>
                  )}

                  <div className="row mt-3 mb-2 px-1">
                    <div className="col-12 d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="isVersantNotRequired"
                        checked={isVersantNotRequired}
                        disabled={interview.finished || !canTakeInterview}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setIsVersantNotRequired(checked);
                          if (!checked) setVersantNotRequiredReason("");
                          if (checked) {
                            saveLog(
                              "VERSANT_NOT_REQUIRED",
                              `Marked Versant as Not Required for candidate ${candidate.name}`,
                            );
                          }
                        }}
                      />
                      &nbsp;&nbsp;
                      <label
                        htmlFor="isVersantNotRequired"
                        className="mb-0 font-weight-bold"
                      >
                        Versant Not Required
                      </label>
                    </div>
                    {isVersantNotRequired && (
                      <div className="col-12 mt-2">
                        <label className="font-weight-bold">
                          Reason <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          value={versantNotRequiredReason}
                          disabled={interview.finished || !canTakeInterview}
                          onChange={(e) =>
                            setVersantNotRequiredReason(e.target.value)
                          }
                        >
                          <option value="">Select Reason</option>
                          <option value="Regional Candidate">
                            Regional Candidate
                          </option>
                          <option value="Movement from NAPS/NATS">
                            Movement from NAPS/NATS
                          </option>
                        </select>
                        {error?.versantNotRequiredReason && (
                          <span style={{ color: "red" }}>
                            {error?.versantNotRequiredReason}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <table className="table table-candidate">
                <tbody>
                  {/* {interview?.type === "L1" && (
                    <>
                      <tr>
                        <td width={"149px"}>
                          <strong>Expected Versant</strong>
                          <span style={{ color: "red" }}>*</span>
                        </td>
                        <td>
                          {interview.finished ||
                            localStorage.getItem("user.role") !==
                            "interviewer" ? (
                            <span>
                              {expectedVersantScore
                                ? `V${expectedVersantScore}`
                                : "N/A"}
                            </span>
                          ) : (
                            <select

                              name="rejected_reason"
                              id="rejected_reason"
                              className="form-control"
                              disabled={expectedVersantScoreDisable}
                              value={expectedVersantScore}
                              onChange={(e) =>
                                setExpectedVersantScore(e.target.value)
                              }
                            >
                              <option value="">---Select--- </option>
                              {["1", "2", "3", "4", "5", "6"]?.map((ele) => {
                                return <option value={ele}>V{ele}</option>;
                              })}
                            </select>
                          )}
                        </td>
                      </tr>
                      {error?.versantScore && (
                        <tr>
                          <td colSpan={2}>
                            <span style={{ color: "red" }}>
                              {error?.versantScore}
                            </span>
                          </td>
                        </tr>
                      )}
                    </>
                  )} */}
                  {candidate?.trf?.candidateType !== "Non-Agent" && (
                    <tr>
                      <td colSpan={2}>
                        <div>
                          <ProfilePhotoMatchAgent
                            space={149}
                            interview={interview}
                            candidate={candidate}
                            agentFaceMatchStatus={agentFaceMatchStatus}
                            setAgentFaceMatchStatus={setAgentFaceMatchStatus}
                            agentNoRecordReason={agentNoRecordReason}
                            setAgentNoRecordReason={setAgentNoRecordReason}
                            recruiterFaceMatchResponse={recruiterFaceMatchResponse}
                            setRecruiterFaceMatchResponse={setRecruiterFaceMatchResponse}
                            autoRejectCandidate={autoRejectCandidate}
                            error={error}
                            candidatePhoto={s3Files}
                            canTakeInterview={canTakeInterview && !interview?.finished}
                            isViewMode={interview?.finished || !canTakeInterview}
                            onRefresh={refreshInterviewDetails}
                          />
                        </div>
                      </td>
                    </tr>
                  )}
                  {candidate?.trf?.candidateType === "Non-Agent" &&
                    (interviewStatus === "Selected" ||
                      interviewStatus === "Suspicious") && (
                      <>
                        <tr>
                          <td colSpan={2}>
                            <div className="mt-3">
                              <ProfilePhotoMatch
                                space={149}
                                interview={interview}
                                candidatePhotoPresent={candidate?.photo}
                                setInterviewMode={setInterviewMode}
                                interviewMode={interviewMode}
                                candidatePhoto={s3Files}
                                photoMatch={photoMatch}
                                setPhotoMatch={setPhotoMatch}
                                setInterviewStatus={setInterviewStatus}
                                concent={concent}
                                setConcent={setConcent}
                                canTakeInterview={canTakeInterview && !interview?.finished}
                              />
                            </div>
                          </td>
                        </tr>
                      </>
                    )}

                  {candidate?.trf?.candidateType !== "Non-Agent" && (interview?.recruiterFaceMatchResponse || interview?.phygitalVerification?.interviewStatus) && (
                    <tr>
                      <td style={{ whiteSpace: "nowrap", width: "170px" }}>
                        <strong>Recruiter's Decision:</strong>
                      </td>
                      <td>
                        <span>
                          {interview?.recruiterFaceMatchResponse
                            ? (interview.recruiterFaceMatchResponse === "Matched" ? "Photo Match" : "Photo Mismatch")
                            : (interview?.phygitalVerification?.interviewStatus
                              ? (interview.phygitalVerification.interviewStatus.toLowerCase() === "no-response"
                                ? "No Response"
                                : (agentFaceMatchStatus === "Mismatch"
                                  ? "Photo Mismatch"
                                  : (interview.phygitalVerification.interviewStatus.toLowerCase() === "approved" || interview.phygitalVerification.interviewStatus.toLowerCase() === "accepted" ? "Photo Match" : "Photo Mismatch")))
                              : "N/A")}
                        </span>
                      </td>
                    </tr>
                  )}
                  <tr
                    hidden={
                      interview.type === "versant" && isVersantNotRequired
                    }
                  >
                    <td width={"149px"}>
                      <strong>Remarks</strong>
                      {interviewStatus !== "Rejected" && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </td>
                    <td>
                      {interview.finished || !canTakeInterview ? (
                        <span>{remarks || "N/A"}</span>
                      ) : (
                        <textarea
                          className="form-control"
                          onChange={(e) => setRemarks(e.target.value)}
                          value={remarks}
                          required
                        ></textarea>
                      )}
                    </td>
                  </tr>
                  {error?.remark && (
                    <tr
                      hidden={
                        interview.type === "versant" && isVersantNotRequired
                      }
                    >
                      <td colSpan={2}>
                        <span style={{ color: "red", fontSize: "13.5px" }}>
                          {error?.remark}
                        </span>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <strong>Status</strong>
                      <span style={{ color: "red" }}>*</span>
                    </td>
                    <td>
                      {interview.finished || !canTakeInterview ? (
                        <span>{interview.status}</span>
                      ) : (
                        <>{interview.status ? interview.status : "NA"}</>
                      )}
                    </td>
                  </tr>
                  {!interview.finished && canTakeInterview && (
                    <tr>
                      <td colSpan={2}>
                        {isAgentCandidate && interview?.phygitalVerification?.candidateJoined && !interview?.phygitalVerification?.submittedAt && !isDevAdmin && (
                          <div className="alert alert-warning p-2 mb-2 font-weight-bold" style={{ fontSize: "12px", borderRadius: "4px" }}>
                            <i className="fa fa-exclamation-triangle mr-1"></i>
                            Since interview is started in DH, You cannot change status in DH until the interview is completed
                          </div>
                        )}
                        <select
                          name="interview_status"
                          id="interview_status"
                          className="col form-control"
                          value={interviewStatus}
                          onChange={(e) => {
                            handleRejectionStatus(e);
                          }}
                          disabled={isAgentCandidate && interview?.phygitalVerification?.candidateJoined && !interview?.phygitalVerification?.submittedAt && !isDevAdmin}
                        >
                          <option value="">---Select--- </option>
                          {filterStatus?.map((reject) => {
                            return (
                              <option value={reject?.name}>
                                {reject?.name}
                              </option>
                            );
                          })}
                        </select>
                      </td>
                    </tr>
                  )}
                  {error?.status && (
                    <tr>
                      <td colSpan={2}>
                        <span style={{ color: "red", fontSize: "13.5px" }}>
                          {error?.status}
                        </span>
                      </td>
                    </tr>
                  )}
                  <tr>
                    {interviewStatus !== "" && (
                      <>
                        {interview.finished && interview.rejectionReason ? (
                          <>
                            <td>
                              <strong>Reason</strong>
                            </td>
                            <td>
                              <span>{interview.rejectionReason}</span>{" "}
                            </td>
                          </>
                        ) : (
                          <td colSpan={2}>
                            {((interviewStatus !== "" &&
                              rejectionReasonParameterList.length !== 0) ||
                              rejectedReason !== "") &&
                              interviewStatus === "Rejected" && (
                                <div>
                                  <label>Select Rejected Reason</label>{" "}
                                  <span style={{ color: "red" }}>*</span>
                                  <select
                                    name="rejected_reason"
                                    id="rejected_reason"
                                    className="form-control"
                                    placeholder="select"
                                    value={rejectedReason}
                                    onChange={handleStatusReason}
                                  // ref={interviewStatusRef}  rejectionReasonParameterList
                                  >
                                    <option selected hidden disabled value="">
                                      {rejectedReason !== ""
                                        ? rejectedReason
                                        : "Select..."}
                                    </option>
                                    {rejectionReasonParameterList?.map(
                                      (reject) => {
                                        return (
                                          <option value={reject?.parameterName}>
                                            {reject?.parameterName}
                                          </option>
                                        );
                                      },
                                    )}
                                  </select>
                                  {error?.rejectReason && (
                                    <b style={{ color: "red" }}>
                                      {error.rejectReason}
                                    </b>
                                  )}
                                </div>
                              )}
                          </td>
                        )}
                      </>
                    )}
                  </tr>
                </tbody>
              </table>

              {interview.finished ? (
                <>
                  {(candidate?.L3_Status === "Selected" &&
                    candidate?.InterviewRound3 === "final") ||
                    (candidate?.InterviewRound4 === "clientRound" &&
                      candidate?.L4_Status === "Selected" &&
                      clientRoundExist === true) ||
                    (candidate?.InterviewRound3 === "versant" &&
                      candidate?.L3_Status === "Selected" &&
                      clientRoundExist === false) ||
                    (candidate?.InterviewRound3 === "clientRound" &&
                      candidate?.L3_Status === "Selected") ? (
                    <>
                      {canEditTrf &&
                        candidate?.IsSelected !== true &&
                        !candidate?.documentsVerifiedStatus && (
                          <>
                            {index === interviews?.length &&
                              interview?.finished && (
                                <button
                                  disabled={editStatus}
                                  className="btn btn-primary mt-2 mr-2"
                                  onClick={onClickUnSubmit}
                                >
                                  Make Editable
                                </button>
                              )}
                          </>
                        )}
                    </>
                  ) : (
                    <div>
                      {canTakeInterview &&
                        ((candidate?.InterviewRound3 === "versant" &&
                          candidate?.L3_Status !== "Selected" &&
                          candidate?.L3_Status !== "Rejected") ||
                          canMakeInterviewEditable ||
                          (candidate?.InterviewRound1 === "L1" &&
                            candidate?.L1_Status !== "Selected" &&
                            candidate?.L1_Status !== "Rejected") ||
                          canMakeInterviewEditable ||
                          (candidate?.InterviewRound2 === "L2" &&
                            candidate?.L2_Status !== "Selected" &&
                            candidate?.L2_Status !== "Rejected") ||
                          canMakeInterviewEditable ||
                          (candidate?.InterviewRound4 === "clientRound" &&
                            candidate?.L4_Status !== "Selected" &&
                            candidate?.L4_Status !== "Rejected") ||
                          canMakeInterviewEditable ||
                          (candidate?.InterviewRound3 === "final" &&
                            candidate?.L3_Status !== "Selected" &&
                            candidate?.L3_Status !== "Rejected") ||
                          canMakeInterviewEditable) &&
                        candidate?.IsSelected !== true && (
                          <>
                            {index === interviews?.length &&
                              interview?.finished && (
                                <button
                                  disabled={editStatus}
                                  className="btn btn-primary mt-2 mr-2"
                                  onClick={onClickUnSubmit}
                                >
                                  Make Editable
                                </button>
                              )}
                          </>
                        )}
                    </div>
                  )}
                </>
              ) : (
                <div>
                  {canTakeInterview && (
                    <button
                      className="btn btn-primary w-full btn-white mt-3 px-4 mr-2"
                      onClick={async () => {
                        let isCall = true;
                        if (interviewStatus === "Suspicious") {
                          isCall = await swal({
                            icon: "error",
                            title: "Do you want to continue?",
                            text: "Selecting this option will deactivate the candidate account.",
                            buttons: {
                              cancel: "Cancel",
                              confirm: "OK",
                            },
                          });
                        }

                        if (isCall) {
                          onClickSubmit();
                        }
                      }}

                      disabled={
                        disable ||
                        (isAgentCandidate && interview?.phygitalVerification?.candidateJoined && !interview?.phygitalVerification?.submittedAt && !isDevAdmin)
                      }
                    >
                      Submit
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Interview;
